import React, { useCallback, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import CauHinhTaiSanApi from "service/CauHinhTaiSanApi";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import NumberFormat from "react-number-format";
function CreateGuid() {
  function _p8(s) {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }
  return _p8() + _p8(true) + _p8(true) + _p8();
}

const ThemSuaCauHinh = ({
  onClose,
  onSearch,
  data,
  isCauHinhT77,
  isTongSoNgay,
}) => {
  const [MaHangHoa, setMaHangHoa] = useState(data?.MaHangHoa ?? "");
  const [CauHinhTaiSanId] = useState(data?.CauHinhTaiSanId);
  const [TenHangHoa, setTenHangHoa] = useState(data?.TenHangHoa ?? "");
  const [TrangThaiHangHoa, setTrangThaiHangHoa] = useState(
    data?.TrangThaiHangHoa ?? 0,
  );
  const [ListThuocTinh, setListThuocTinh] = useState(
    data?.ThuocTinhTaiSan ?? [],
  );
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});

  //
  const [SuDungCauHinhTaiSan, setSuDungCauHinhTaiSan] = useState(
    data?.SuDungCauHinhTaiSan ?? false,
  );
  const [ckbKyDongLai_Ngay, setckbKyDongLai_Ngay] = useState(
    data?.ckbKyDongLai_Ngay ?? false,
  );
  const [ckbKyDongLai_Tuan, setckbKyDongLai_Tuan] = useState(
    data?.ckbKyDongLai_Tuan ?? false,
  );
  const [ckbKyDongLai_Thang, setckbKyDongLai_Thang] = useState(
    data?.ckbKyDongLai_Thang ?? false,
  );
  const [ckbKyDongLai_ThangDinhKy, setckbKyDongLai_ThangDinhKy] = useState(
    data?.ckbKyDongLai_ThangDinhKy ?? false,
  );
  const [selectedKyDongLai, setselectedKyDongLai] = useState(
    data?.selectedKyDongLai ?? 0,
  );
  const [inputKyDongLai, setinputKyDongLai] = useState(
    data?.inputKyDongLai ?? "",
  );
  const [inputSoTienVay, setinputSoTienVay] = useState(
    data?.inputSoTienVay ?? "",
  );
  const [inputSoLanTra, setinputSoLanTra] = useState(data?.inputSoLanTra ?? "");
  const [inputTongSoNgay, setinputTongSoNgay] = useState(
    data?.inputTongSoNgay ?? "",
  );
  const [ckbLaiNgay_LaiTrieuNgay, setckbLaiNgay_LaiTrieuNgay] = useState(
    data?.ckbLaiNgay_LaiTrieuNgay ?? false,
  );
  const [ckbLaiNgay_LaiNgay, setckbLaiNgay_LaiNgay] = useState(
    data?.ckbLaiNgay_LaiNgay ?? false,
  );
  const [ckbLaiNgay_LaiPhanTramThang, setckbLaiNgay_LaiPhanTramThang] =
    useState(data?.ckbLaiNgay_LaiPhanTramThang ?? false);
  const [ckbLaiNgay_LaiKy, setckbLaiNgay_LaiKy] = useState(
    data?.ckbLaiNgay_LaiKy ?? false,
  );
  const [ckbLaiNgay_LaiPhanTramDinhKy, setckbLaiNgay_LaiPhanTramDinhKy] =
    useState(data?.ckbLaiNgay_LaiPhanTramDinhKy ?? false);
  const [selectedLaiNgay, setselectedLaiNgay] = useState(
    data?.selectedLaiNgay ?? 0,
  );
  const [inputLaiNgay, setinputLaiNgay] = useState(data?.inputLaiNgay ?? "");
  const [ckbLaiTuan_LaiTuan, setckbLaiTuan_LaiTuan] = useState(
    data?.ckbLaiTuan_LaiTuan === true ?? false,
  );
  const [ckbLaiTuan_LaiPhanTramTuan, setckbLaiTuan_LaiPhanTramTuan] = useState(
    data?.ckbLaiTuan_LaiPhanTramTuan === true ?? false,
  );
  const [selectedLaiTuan, setselectedLaiTuan] = useState(
    data?.selectedLaiTuan ?? 0,
  );
  const [inputLaiTuan, setinputLaiTuan] = useState(data?.inputLaiTuan ?? "");
  const [ckbLaiThang_LaiTrieuNgay, setckbLaiThang_LaiTrieuNgay] = useState(
    data?.ckbLaiThang_LaiTrieuNgay ?? false,
  );
  const [ckbLaiThang_LaiNgay, setckbLaiThang_LaiNgay] = useState(
    data?.ckbLaiThang_LaiNgay ?? false,
  );
  const [ckbLaiThang_LaiPhanTramThang, setckbLaiThang_LaiPhanTramThang] =
    useState(data?.ckbLaiThang_LaiPhanTramThang ?? false);
  const [selectedLaiThang, setselectedLaiThang] = useState(
    data?.selectedLaiThang ?? 0,
  );
  const [inputLaiThang, setinputLaiThang] = useState(data?.inputLaiThang ?? "");
  const [ckbKieuThanhToan_HienThiTatCa, setckbKieuThanhToan_HienThiTatCa] =
    useState(data?.ckbKieuThanhToan_HienThiTatCa ?? false);
  const [selectedKieuThanhToan, setselectedKieuThanhToan] = useState(
    data?.selectedKieuThanhToan ?? null,
  );
  const CustomCheckbox = ({
    id,
    name,
    checked,
    onChange,
    label,
    className = "",
  }) => (
    <div className={`form-group ${className}`}>
      <label htmlFor={id} className="custom-control custom-checkbox">
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          onChange={onChange}
          className="custom-control-input"
        />
        <span className="custom-control-indicator"></span>
        <span style={{ marginLeft: "1rem", fontSize: "15px" }}>{label}</span>
      </label>
    </div>
  );

  const CustomRadio = ({
    id,
    name,
    value,
    checked,
    onChange,
    label,
    dataType,
    className = "",
  }) => (
    <div className={`form-group ${className}`}>
      <label htmlFor={id} className="custom-control custom-radio">
        <input
          type="radio"
          id={id}
          name={name}
          value={value}
          data-type={dataType}
          checked={checked}
          onChange={onChange}
          className="custom-control-input"
        />
        <span className="custom-control-indicator"></span>
        <span style={{ marginLeft: "1rem", fontSize: "15px" }}>{label}</span>
      </label>
    </div>
  );
  const handleInputChange = (e) => {
    const { name, type, checked, value, dataset } = e.target;
    const isNumericRadio = dataset?.type === "number";
    const finalValue =
      type === "checkbox" ? checked : isNumericRadio ? Number(value) : value;

    switch (name) {
      case "SuDungCauHinhTaiSan":
        setSuDungCauHinhTaiSan(finalValue);
        break;
      case "ckbKyDongLai_Ngay":
        setckbKyDongLai_Ngay(finalValue);
        break;
      case "ckbKyDongLai_Tuan":
        setckbKyDongLai_Tuan(finalValue);
        break;
      case "ckbKyDongLai_Thang":
        setckbKyDongLai_Thang(finalValue);
        break;
      case "ckbKyDongLai_ThangDinhKy":
        setckbKyDongLai_ThangDinhKy(finalValue);
        break;
      case "selectedKyDongLai":
        setselectedKyDongLai(finalValue);
        break;
      case "inputKyDongLai":
        setinputKyDongLai(finalValue);
        break;
      case "ckbLaiNgay_LaiTrieuNgay":
        setckbLaiNgay_LaiTrieuNgay(finalValue);
        break;
      case "ckbLaiNgay_LaiNgay":
        setckbLaiNgay_LaiNgay(finalValue);
        break;
      case "ckbLaiNgay_LaiPhanTramThang":
        setckbLaiNgay_LaiPhanTramThang(finalValue);
        break;
      case "ckbLaiNgay_LaiKy":
        setckbLaiNgay_LaiKy(finalValue);
        break;
      case "ckbLaiNgay_LaiPhanTramDinhKy":
        setckbLaiNgay_LaiPhanTramDinhKy(finalValue);
        break;
      case "selectedLaiNgay":
        setselectedLaiNgay(finalValue);
        break;
      case "inputLaiNgay":
        setinputLaiNgay(finalValue);
        break;
      case "ckbLaiTuan_LaiTuan":
        setckbLaiTuan_LaiTuan(finalValue);
        break;
      case "ckbLaiTuan_LaiPhanTramTuan":
        setckbLaiTuan_LaiPhanTramTuan(finalValue);
        break;
      case "selectedLaiTuan":
        setselectedLaiTuan(finalValue);
        break;
      case "inputLaiTuan":
        setinputLaiTuan(finalValue);
        break;
      case "ckbLaiThang_LaiNgay":
        setckbLaiThang_LaiNgay(finalValue);
        break;
      case "ckbLaiThang_LaiPhanTramThang":
        setckbLaiThang_LaiPhanTramThang(finalValue);
        break;
      case "ckbLaiThang_LaiTrieuNgay":
        setckbLaiThang_LaiTrieuNgay(finalValue);
        break;
      case "selectedLaiThang":
        setselectedLaiThang(finalValue);
        break;
      case "inputLaiThang":
        setinputLaiThang(finalValue);
        break;
      case "ckbKieuThanhToan_HienThiTatCa":
        setckbKieuThanhToan_HienThiTatCa(finalValue);
        if (finalValue && selectedKieuThanhToan != null)
          setselectedKieuThanhToan(selectedKieuThanhToan);
        if (finalValue && selectedKieuThanhToan == null)
          setselectedKieuThanhToan(0);
        break;
      case "selectedKieuThanhToan":
        setselectedKieuThanhToan(finalValue);
        break;
      default:
        break;
    }
  };

  const handleSelectAll = (e) => {
    const { name, checked } = e.target;

    switch (name) {
      case "chonTatCaKyDongLai":
        setckbKyDongLai_Ngay(checked);
        setckbKyDongLai_Tuan(checked);
        setckbKyDongLai_Thang(checked);
        setckbKyDongLai_ThangDinhKy(checked);
        if (checked && selectedKyDongLai != 0)
          setselectedKyDongLai(selectedKyDongLai);
        if (checked && selectedKyDongLai == 0) setselectedKyDongLai(1);
        break;
      case "chonTatCaLaiNgay":
        setckbLaiNgay_LaiKy(checked);
        setckbLaiNgay_LaiNgay(checked);
        setckbLaiNgay_LaiPhanTramDinhKy(checked);
        setckbLaiNgay_LaiPhanTramThang(checked);
        setckbLaiNgay_LaiTrieuNgay(checked);
        if (checked && selectedLaiNgay != 0)
          setselectedLaiNgay(selectedLaiNgay);
        if (checked && selectedLaiNgay == 0) setselectedLaiNgay(1);
        break;
      case "chonTatCaLaiTuan":
        setckbLaiTuan_LaiTuan(checked);
        setckbLaiTuan_LaiPhanTramTuan(checked);
        if (checked && selectedLaiTuan != 0)
          setselectedLaiTuan(selectedLaiTuan);
        if (checked && selectedLaiTuan == 0) setselectedLaiTuan(6);
        break;
      case "chonTatCaLaiThang":
        setckbLaiThang_LaiNgay(checked);
        setckbLaiThang_LaiPhanTramThang(checked);
        setckbLaiThang_LaiTrieuNgay(checked);
        if (!checked) setselectedLaiThang(0);
        if (checked && selectedLaiThang != 0)
          setselectedLaiThang(selectedLaiThang);
        if (checked && selectedLaiThang == 0) setselectedLaiThang(1);
        break;
      default:
        break;
    }
  };

  const onChangeValueThuocTinh = (index) => (evt) => {
    const newList = [...ListThuocTinh];
    newList[index] = { ...newList[index], ValueThuocTinh: evt.target.value };
    setListThuocTinh(newList);
  };
  const themThuocTinh = () => {
    setListThuocTinh([
      ...ListThuocTinh,
      { MaThuocTinh: CreateGuid(), ValueThuocTinh: "" },
    ]);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Escape") onClose();
  };

  useEffect(() => {
    console.log("[ThemSuaCauHinh] isTongSoNgay", isTongSoNgay, {
      inputSoLanTra: data?.inputSoLanTra,
      inputTongSoNgay: data?.inputTongSoNgay,
    });
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);
  const validate = () => {
    let newErrors = {};
    if (!MaHangHoa.trim()) newErrors.MaHangHoa = "Hãy nhập mã loại tài sản";
    if (!TenHangHoa.trim()) newErrors.TenHangHoa = "Hãy nhập tên loại tài sản";
    return newErrors;
  };
  const checkNewCode = useCallback(async (data) => {
    try {
      const res = await CauHinhTaiSanApi.checkNewCode(data);
      return res.data;
    } catch (error) {
      console.error("Lỗi load new code:", error);
      return false;
    }
  }, []);

  const onSaveThemSuaCauHinhTaiSan = async (data) => {
    let success = "";
    let error = "";
    try {
      const res = await CauHinhTaiSanApi.addorupdate(data);
      const dataResponse = res.data;
      if (res.status === 200) {
        if (data.CauHinhTaiSanId !== 0) {
          success = "Sửa thành công.";
          onClose();
        } else {
          success = "Thêm mới thành công.";
          onClose();
        }
        pushNotification(success, "success", "TOP_CENTER", 1000);
        onSearch();
      } else {
        if (data.CauHinhTaiSanId !== 0) {
          error = "Sửa thất bại: " + dataResponse;
        } else {
          error = dataResponse.Messages;
          console.log("Error: ", error);
        }
        pushNotification(error, "error", "TOP_CENTER", 1000);
      }
    } catch (err) {
      console.error("Lỗi:", err);
      if (data.CauHinhTaiSanId !== 0) {
        error = "Lỗi khi gọi Api Sửa!";
      } else {
        error = "Lỗi khi gọi Api Thêm mới!";
      }
      pushNotification(error, "error", "TOP_CENTER", 1000);
    }
  };
  const handleSave = async () => {
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    const filteredThuocTinh = ListThuocTinh.filter(
      (tt) => tt.ValueThuocTinh?.trim() !== "",
    );
    setErrors({});
    setSaving(true);
    try {
      const valid = await checkNewCode({
        id: CauHinhTaiSanId,
        mahanghoa: MaHangHoa,
      });
      if (!valid) {
        pushNotification(
          "Mã loại tài sản đã tồn tại!",
          "error",
          "TOP_CENTER",
          1000,
        );
        return;
      }
      const payload = {
        CauHinhTaiSanId,
        TenHangHoa,
        MaHangHoa,
        TrangThaiHangHoa,
        ThuocTinhTaiSan: filteredThuocTinh,
        SuDungCauHinhTaiSan,
        inputKyDongLai,
        inputSoTienVay,
        inputSoLanTra,
        inputTongSoNgay,
        inputLaiNgay,
        inputLaiThang,
        inputLaiTuan,
        ckbKyDongLai_Ngay,
        ckbKyDongLai_Thang,
        ckbKyDongLai_ThangDinhKy,
        ckbKyDongLai_Tuan,
        ckbLaiNgay_LaiTrieuNgay,
        ckbLaiNgay_LaiNgay,
        ckbLaiNgay_LaiPhanTramThang,
        ckbLaiNgay_LaiKy,
        ckbLaiNgay_LaiPhanTramDinhKy,
        ckbLaiTuan_LaiTuan,
        ckbLaiTuan_LaiPhanTramTuan,
        ckbLaiThang_LaiTrieuNgay,
        ckbLaiThang_LaiNgay,
        ckbLaiThang_LaiPhanTramThang,
        selectedKyDongLai,
        selectedLaiNgay,
        selectedLaiTuan,
        selectedLaiThang,
        ckbKieuThanhToan_HienThiTatCa,
        selectedKieuThanhToan,
      };
      console.log("datasave payload: ", payload);
      await onSaveThemSuaCauHinhTaiSan(payload);
    } catch (err) {
      console.error("Lỗi khi lưu:", err);
      pushNotification(
        "Có lỗi xảy ra khi lưu. Vui lòng thử lại.",
        "error",
        "TOP_CENTER",
        1000,
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Modal
        show={true}
        dialogClassName="modal-90w"
        centered
        className="modal-new modal fade text-left popup-detail"
        animation={true}
      >
        <Modal.Header>
          <h4
            className="modal-title"
            style={{ paddingLeft: "15px", fontWeight: "bold" }}
          >
            {!data?.CauHinhTaiSanId || data.CauHinhTaiSanId === 0
              ? "Thêm mới loại tài sản"
              : "Sửa loại tài sản"}
          </h4>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-end",
            }}
          >
            <button
              type="button"
              className="close-popup-new"
              onClick={onClose}
              disabled={saving}
            >
              <i className="mdi mdi-close"></i>
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <h3
            className="lead collapsed"
            style={{
              borderBottom: "1px solid black",
              paddingBottom: "5px",
              color: "#00B69B",
              fontWeight: "bold",
            }}
          >
            Thông tin chung
          </h3>
          <div className="row" style={{ paddingTop: "5px" }}>
            <div className="col-md-4">
              <div className="form-group">
                <label style={{ fontWeight: "bold" }}>Lĩnh vực</label>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  value={
                    isCauHinhT77
                      ? "Cầm đồ + Huy động vốn + Trả góp"
                      : "Cầm đồ + Huy động vốn"
                  }
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label style={{ fontWeight: "bold" }}>
                  Mã loại tài sản <span className="text-danger">(*)</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={MaHangHoa}
                  onChange={(e) => setMaHangHoa(e.target.value)}
                  placeholder="Ví dụ:XM"
                />
                {errors.MaHangHoa && (
                  <div className="text-danger">{errors.MaHangHoa}</div>
                )}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label style={{ fontWeight: "bold" }}>
                  Tên loại tài sản <span className="text-danger">(*)</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={TenHangHoa}
                  onChange={(e) => setTenHangHoa(e.target.value)}
                  placeholder="Nhập địa chỉ"
                />
                {errors.TenHangHoa && (
                  <div className="text-danger">{errors.TenHangHoa}</div>
                )}
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label style={{ fontWeight: "bold" }}>Trạng thái</label>
                <select
                  className="form-control"
                  value={TrangThaiHangHoa}
                  onChange={(e) => setTrangThaiHangHoa(Number(e.target.value))}
                >
                  <option value="0">Bình thường</option>
                  <option value="1">Khóa</option>
                </select>
              </div>
            </div>
          </div>
          <h3
            className="lead collapsed"
            style={{
              borderBottom: "1px solid black",
              paddingBottom: "5px",
              color: "#00B69B",
              fontWeight: "bold",
            }}
          >
            Cấu hình thuộc tính hàng hóa
          </h3>
          <div className="row" style={{ paddingTop: "5px" }}>
            {ListThuocTinh &&
              ListThuocTinh.map((item, index) => (
                <div className="col-md-4">
                  <TextInputOnRow
                    labelClass="label-control text-bold"
                    inputClass="form-control"
                    wrapperClass="form-group"
                    labelText={"Thuộc tính " + (index + 1)}
                    placeholder="VD: Biển số xe"
                    inputProps={{
                      name: "ListThuocTinhTaiSan[" + index + "].ValueThuocTinh",
                      value: item.ValueThuocTinh,
                      onChange: onChangeValueThuocTinh(index),
                    }}
                  ></TextInputOnRow>
                  {errors[`ThuocTinh_${index}`] && (
                    <div className="text-danger">
                      {errors[`ThuocTinh_${index}`]}
                    </div>
                  )}
                  <input
                    type="text"
                    className="hidden"
                    name={"ListThuocTinhTaiSan[" + index + "].MaThuocTinh"}
                    value={item.MaThuocTinh}
                  ></input>
                </div>
              ))}
            <div className="col-md-4">
              <div
                className="form-group"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  maxWidth: "180px",
                }}
              >
                <label htmlFor="add">
                  <span>&nbsp;</span>
                </label>
                <button
                  id="add"
                  type="button"
                  className="btn btn-info"
                  onClick={themThuocTinh}
                >
                  <i className="la la-plus"></i> Thêm thuộc tính
                </button>
              </div>
            </div>
          </div>
          <h3
            className="lead collapsed"
            style={{
              borderBottom: "1px solid black",
              paddingBottom: "5px",
              color: "#00B69B",
              fontWeight: "bold",
            }}
          >
            Cấu hình tính lãi
          </h3>
          <div className="column" style={{ paddingTop: "5px" }}>
            <div
              className="form-group row form-date-mm ky-dong-lai-section"
              style={{ paddingLeft: "15px" }}
            >
              <label
                className="col-md-2 label-control text-bold"
                style={{ whiteSpace: "nowrap" }}
              >
                Sử dụng cấu hình tài sản
              </label>
              <div className="col-md-10">
                <CustomCheckbox
                  id="SuDungCauHinhTaiSan"
                  name="SuDungCauHinhTaiSan"
                  checked={SuDungCauHinhTaiSan}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div
              className="form-group row"
              style={{
                paddingLeft: "15px",
                display: SuDungCauHinhTaiSan ? "flex" : "none",
              }}
            >
              <label className="col-md-2 label-control text-bold">
                Tổng tiền vay
              </label>
              <div className="col-md-3">
                <NumberFormat
                  className="form-control"
                  thousandSeparator
                  allowNegative={false}
                  decimalScale={0}
                  placeholder="Giá trị mặc định"
                  value={inputSoTienVay}
                  onValueChange={(v) => setinputSoTienVay(v.floatValue ?? "")}
                />
              </div>
              {isTongSoNgay ? (
                <>
                  <label className="col-md-2 label-control text-bold">
                    Tổng số ngày trả lãi
                  </label>
                  <div className="col-md-3">
                    <NumberFormat
                      className="form-control"
                      allowNegative={false}
                      decimalScale={0}
                      placeholder="Giá trị mặc định"
                      value={inputTongSoNgay}
                      onValueChange={(v) =>
                        setinputTongSoNgay(v.floatValue ?? "")
                      }
                    />
                  </div>
                </>
              ) : (
                <>
                  <label className="col-md-2 label-control text-bold">
                    Số kỳ đóng lãi
                  </label>
                  <div className="col-md-3">
                    <NumberFormat
                      className="form-control"
                      allowNegative={false}
                      decimalScale={0}
                      placeholder="Giá trị mặc định"
                      value={inputSoLanTra}
                      onValueChange={(v) =>
                        setinputSoLanTra(v.floatValue ?? "")
                      }
                    />
                  </div>
                </>
              )}
            </div>
            <div
              className="form-group row form-date-mm ky-dong-lai-section"
              style={{
                paddingLeft: "15px",
                display: SuDungCauHinhTaiSan ? "flex" : "none",
              }}
            >
              <label className="col-md-2 label-control text-bold">
                Kỳ đóng lãi
              </label>
              <div className="col-md-10">
                {
                  <CustomCheckbox
                    id="chonTatCaKyDongLai"
                    name="chonTatCaKyDongLai"
                    checked={
                      ckbKyDongLai_Ngay &&
                      ckbKyDongLai_Thang &&
                      ckbKyDongLai_ThangDinhKy &&
                      ckbKyDongLai_Tuan
                    }
                    onChange={handleSelectAll}
                    label="Chọn tất cả"
                  />
                }
                <div
                  className="d-flex config-container"
                  style={{ marginTop: "1rem" }}
                >
                  <div className="config-card flex-grow-1">
                    <div className="config-card-header text-bold">
                      DANH SÁCH
                    </div>
                    <div className="config-card-body">
                      {
                        <CustomCheckbox
                          id="checkNgay"
                          name="ckbKyDongLai_Ngay"
                          checked={ckbKyDongLai_Ngay}
                          onChange={handleInputChange}
                          label="Ngày"
                        />
                      }
                      {
                        <CustomCheckbox
                          id="checkTuan"
                          name="ckbKyDongLai_Tuan"
                          checked={ckbKyDongLai_Tuan}
                          onChange={handleInputChange}
                          label="Tuần"
                        />
                      }
                      {
                        <CustomCheckbox
                          id="checkThang"
                          name="ckbKyDongLai_Thang"
                          checked={ckbKyDongLai_Thang}
                          onChange={handleInputChange}
                          label="Tháng"
                        />
                      }
                      {
                        <CustomCheckbox
                          id="checkThangDinhKy"
                          name="ckbKyDongLai_ThangDinhKy"
                          checked={ckbKyDongLai_ThangDinhKy}
                          onChange={handleInputChange}
                          label="Tháng định kỳ"
                        />
                      }
                    </div>
                  </div>
                  <div className="config-card flex-grow-1">
                    <div className="config-card-header text-bold">
                      NHÃN ĐƯỢC CHỌN
                    </div>
                    <div className="config-card-body">
                      {ckbKyDongLai_Ngay && (
                        <CustomRadio
                          id="radioNgay"
                          name="selectedKyDongLai"
                          value={1}
                          dataType="number"
                          checked={selectedKyDongLai === 1}
                          onChange={handleInputChange}
                          label="Ngày"
                        />
                      )}
                      {ckbKyDongLai_Tuan && (
                        <CustomRadio
                          id="radioTuan"
                          name="selectedKyDongLai"
                          value={4}
                          dataType="number"
                          checked={selectedKyDongLai === 4}
                          onChange={handleInputChange}
                          label="Tuần"
                        />
                      )}
                      {ckbKyDongLai_Thang && (
                        <CustomRadio
                          id="radioThang"
                          name="selectedKyDongLai"
                          value={2}
                          dataType="number"
                          checked={selectedKyDongLai === 2}
                          onChange={handleInputChange}
                          label="Tháng"
                        />
                      )}
                      {ckbKyDongLai_ThangDinhKy && (
                        <CustomRadio
                          id="radioThangDinhKy"
                          name="selectedKyDongLai"
                          value={3}
                          dataType="number"
                          checked={selectedKyDongLai === 3}
                          onChange={handleInputChange}
                          label="Tháng định kỳ"
                        />
                      )}
                      {
                        <div className="mt-1">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Giá trị mặc định"
                            name="inputKyDongLai"
                            value={inputKyDongLai || ""}
                            onChange={handleInputChange}
                          />
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="form-group row form-date-mm lai-suat-section"
              style={{
                paddingLeft: "15px",
                display: SuDungCauHinhTaiSan ? "flex" : "none",
              }}
            >
              <label className="col-md-2 label-control text-bold">
                Lãi suất
              </label>
              <div className="col-md-10">
                {
                  <CustomCheckbox
                    id="chonTatCaLaiNgay"
                    name="chonTatCaLaiNgay"
                    checked={
                      ckbLaiNgay_LaiKy &&
                      ckbLaiNgay_LaiNgay &&
                      ckbLaiNgay_LaiPhanTramDinhKy &&
                      ckbLaiNgay_LaiPhanTramThang &&
                      ckbLaiNgay_LaiTrieuNgay
                    }
                    onChange={handleSelectAll}
                    label="Chọn tất cả"
                  />
                }
                {
                  <React.Fragment key="lai-suat-ngay">
                    <div className="interest-rate-group">
                      <h4 className="interest-rate-title text-bold">
                        Kỳ đóng lãi: Ngày
                      </h4>
                      <div className="d-flex config-container">
                        <div className="config-card flex-grow-1">
                          <div className="config-card-header text-bold">
                            Danh sách
                          </div>
                          <div className="config-card-body">
                            {
                              <CustomCheckbox
                                id="ckbLaiNgay_LaiTrieuNgay"
                                name="ckbLaiNgay_LaiTrieuNgay"
                                checked={ckbLaiNgay_LaiTrieuNgay}
                                onChange={handleInputChange}
                                label="Lãi/Triệu/Ngày"
                              />
                            }
                            {
                              <CustomCheckbox
                                id="ckbLaiNgay_LaiNgay"
                                name="ckbLaiNgay_LaiNgay"
                                checked={ckbLaiNgay_LaiNgay}
                                onChange={handleInputChange}
                                label="Lãi ngày"
                              />
                            }
                            {
                              <CustomCheckbox
                                id="ckbLaiNgay_LaiPhanTramThang"
                                name="ckbLaiNgay_LaiPhanTramThang"
                                checked={ckbLaiNgay_LaiPhanTramThang}
                                onChange={handleInputChange}
                                label="Lãi tháng (%)"
                              />
                            }
                            {
                              <CustomCheckbox
                                id="ckbLaiNgay_LaiKy"
                                name="ckbLaiNgay_LaiKy"
                                checked={ckbLaiNgay_LaiKy}
                                onChange={handleInputChange}
                                label="Lãi kỳ"
                              />
                            }
                            {
                              <CustomCheckbox
                                id="ckbLaiNgay_LaiPhanTramDinhKy"
                                name="ckbLaiNgay_LaiPhanTramDinhKy"
                                checked={ckbLaiNgay_LaiPhanTramDinhKy}
                                onChange={handleInputChange}
                                label="Lãi % định kỳ"
                              />
                            }
                          </div>
                        </div>
                        <div className="config-card flex-grow-1">
                          <div className="config-card-header text-bold">
                            Nhãn được chọn
                          </div>
                          <div className="config-card-body">
                            {ckbLaiNgay_LaiTrieuNgay && (
                              <CustomRadio
                                id="rdTrieuNgayNgay"
                                name="selectedLaiNgay"
                                value={1}
                                dataType="number"
                                checked={selectedLaiNgay === 1}
                                onChange={handleInputChange}
                                label="Lãi/Triệu/Ngày"
                              />
                            )}
                            {ckbLaiNgay_LaiNgay && (
                              <CustomRadio
                                id="rdNgayNgay"
                                name="selectedLaiNgay"
                                value={2}
                                dataType="number"
                                checked={selectedLaiNgay === 2}
                                onChange={handleInputChange}
                                label="Lãi ngày"
                              />
                            )}
                            {ckbLaiNgay_LaiPhanTramThang && (
                              <CustomRadio
                                id="rdThangNgay"
                                name="selectedLaiNgay"
                                value={3}
                                dataType="number"
                                checked={selectedLaiNgay === 3}
                                onChange={handleInputChange}
                                label="Lãi tháng (%)"
                              />
                            )}
                            {ckbLaiNgay_LaiKy && (
                              <CustomRadio
                                id="rdKyNgay"
                                name="selectedLaiNgay"
                                value={4}
                                dataType="number"
                                checked={selectedLaiNgay === 4}
                                onChange={handleInputChange}
                                label="Lãi kỳ"
                              />
                            )}
                            {ckbLaiNgay_LaiPhanTramDinhKy && (
                              <CustomRadio
                                id="rdPtKyNgay"
                                name="selectedLaiNgay"
                                value={5}
                                dataType="number"
                                checked={selectedLaiNgay === 5}
                                onChange={handleInputChange}
                                label="Lãi % định kỳ"
                              />
                            )}
                            <input
                              type="text"
                              className="form-control mt-1"
                              name="inputLaiNgay"
                              value={inputLaiNgay}
                              onChange={handleInputChange}
                              placeholder="Giá trị mặc định"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                }
                {
                  <CustomCheckbox
                    id="chonTatCaLaiTuan"
                    name="chonTatCaLaiTuan"
                    checked={ckbLaiTuan_LaiTuan && ckbLaiTuan_LaiPhanTramTuan}
                    onChange={handleSelectAll}
                    label="Chọn tất cả"
                  />
                }
                {
                  <React.Fragment key="lai-suat-tuan">
                    <div className="interest-rate-group">
                      <h4 className="interest-rate-title text-bold">
                        Kỳ đóng lãi: Tuần
                      </h4>
                      <div className="d-flex config-container">
                        <div className="config-card flex-grow-1">
                          <div className="config-card-header text-bold">
                            Danh sách
                          </div>
                          <div className="config-card-body">
                            {
                              <CustomCheckbox
                                id="ckbLaiTuan_LaiTuan"
                                name="ckbLaiTuan_LaiTuan"
                                checked={ckbLaiTuan_LaiTuan}
                                onChange={handleInputChange}
                                label="Lãi tuần"
                              />
                            }
                            {
                              <CustomCheckbox
                                id="ckbLaiTuan_LaiPhanTramTuan"
                                name="ckbLaiTuan_LaiPhanTramTuan"
                                checked={ckbLaiTuan_LaiPhanTramTuan}
                                onChange={handleInputChange}
                                label="Lãi % tuần"
                              />
                            }
                          </div>
                        </div>
                        <div className="config-card flex-grow-1">
                          <div className="config-card-header text-bold">
                            Nhãn được chọn
                          </div>
                          <div className="config-card-body">
                            {ckbLaiTuan_LaiTuan && (
                              <CustomRadio
                                id="rdTuanTuan"
                                name="selectedLaiTuan"
                                value={6}
                                dataType="number"
                                checked={selectedLaiTuan === 6}
                                onChange={handleInputChange}
                                label="Lãi tuần"
                              />
                            )}
                            {ckbLaiTuan_LaiPhanTramTuan && (
                              <CustomRadio
                                id="rdPtTuan"
                                name="selectedLaiTuan"
                                value={7}
                                dataType="number"
                                checked={selectedLaiTuan === 7}
                                onChange={handleInputChange}
                                label="Lãi % tuần"
                              />
                            )}
                            <input
                              type="text"
                              className="form-control mt-1"
                              name="inputLaiTuan"
                              value={inputLaiTuan}
                              onChange={handleInputChange}
                              placeholder="Giá trị mặc định"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                }
                {
                  <CustomCheckbox
                    id="chonTatCaLaiThang"
                    name="chonTatCaLaiThang"
                    checked={
                      ckbLaiThang_LaiTrieuNgay &&
                      ckbLaiThang_LaiNgay &&
                      ckbLaiThang_LaiPhanTramThang
                    }
                    onChange={handleSelectAll}
                    label="Chọn tất cả"
                  />
                }
                {
                  <React.Fragment key="lai-suat-thang">
                    <div className="interest-rate-group">
                      <h4 className="interest-rate-title text-bold">
                        Kỳ đóng lãi: Tháng
                      </h4>
                      <div className="d-flex config-container">
                        <div className="config-card flex-grow-1">
                          <div className="config-card-header text-bold">
                            Danh sách
                          </div>
                          <div className="config-card-body">
                            {
                              <CustomCheckbox
                                id="ckbLaiThang_LaiTrieuNgay"
                                name="ckbLaiThang_LaiTrieuNgay"
                                checked={ckbLaiThang_LaiTrieuNgay}
                                onChange={handleInputChange}
                                label="Lãi/Triệu/Ngày"
                              />
                            }
                            {
                              <CustomCheckbox
                                id="ckbLaiThang_LaiNgay"
                                name="ckbLaiThang_LaiNgay"
                                checked={ckbLaiThang_LaiNgay}
                                onChange={handleInputChange}
                                label="Lãi ngày"
                              />
                            }
                            {
                              <CustomCheckbox
                                id="ckbLaiThang_LaiPhanTramThang"
                                name="ckbLaiThang_LaiPhanTramThang"
                                checked={ckbLaiThang_LaiPhanTramThang}
                                onChange={handleInputChange}
                                label="Lãi tháng (%)"
                              />
                            }
                          </div>
                        </div>
                        <div className="config-card flex-grow-1">
                          <div className="config-card-header text-bold">
                            Nhãn được chọn
                          </div>
                          <div className="config-card-body">
                            {ckbLaiThang_LaiTrieuNgay && (
                              <CustomRadio
                                id="rdTrieuNgayThang"
                                name="selectedLaiThang"
                                value={1}
                                dataType="number"
                                checked={selectedLaiThang === 1}
                                onChange={handleInputChange}
                                label="Lãi/Triệu/Ngày"
                              />
                            )}
                            {ckbLaiThang_LaiNgay && (
                              <CustomRadio
                                id="rdNgayThang"
                                name="selectedLaiThang"
                                value={2}
                                dataType="number"
                                checked={selectedLaiThang === 2}
                                onChange={handleInputChange}
                                label="Lãi ngày"
                              />
                            )}
                            {ckbLaiThang_LaiPhanTramThang && (
                              <CustomRadio
                                id="rdThangThang"
                                name="selectedLaiThang"
                                value={3}
                                dataType="number"
                                checked={selectedLaiThang === 3}
                                onChange={handleInputChange}
                                label="Lãi tháng (%)"
                              />
                            )}
                            <input
                              type="text"
                              className="form-control mt-1"
                              name="inputLaiThang"
                              value={inputLaiThang}
                              onChange={handleInputChange}
                              placeholder="Giá trị mặc định"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                }
              </div>
            </div>
            <div
              className="form-group row"
              style={{
                paddingLeft: "15px",
                display: SuDungCauHinhTaiSan ? "flex" : "none",
              }}
            >
              <label className="col-md-2 label-control text-bold">
                Kiểu thanh toán
              </label>
              <div className="col-md-10">
                {
                  <CustomCheckbox
                    id="allBeforeAfter"
                    name="ckbKieuThanhToan_HienThiTatCa"
                    checked={ckbKieuThanhToan_HienThiTatCa}
                    onChange={handleInputChange}
                    label="Hiển thị tất cả (Chọn mặc định)"
                  />
                }
                <div className="d-flex align-items-center mt-2">
                  {ckbKieuThanhToan_HienThiTatCa && (
                    <CustomRadio
                      id="traTruocCD"
                      name="selectedKieuThanhToan"
                      value={1}
                      dataType="number"
                      checked={selectedKieuThanhToan === 1}
                      onChange={handleInputChange}
                      label="Trước"
                      className="mb-0 mr-3"
                    />
                  )}
                  {ckbKieuThanhToan_HienThiTatCa && (
                    <CustomRadio
                      id="traSauCD"
                      name="selectedKieuThanhToan"
                      value={0}
                      dataType="number"
                      checked={selectedKieuThanhToan === 0}
                      onChange={handleInputChange}
                      label="Sau"
                      className="mb-0"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            position: "sticky",
            bottom: "0",
            background: "#fff",
            zIndex: "1055",
          }}
        >
          <button
            className="btn btn-new-main btn-closenew"
            onClick={onClose}
            disabled={saving}
          >
            <i className="mdi mdi-close"></i>&nbsp; Đóng
          </button>
          <button
            className="btn "
            onClick={handleSave}
            disabled={saving}
            style={{
              background: "#056569",
              color: "white",
              borderRadius: "6px",
              fontSize: "15px",
              textTransform: "none",
            }}
          >
            {saving ? (
              <>
                <span className="spinner-border spinner-border-sm"></span>&nbsp;
                Đang lưu...
              </>
            ) : (
              <>
                <i className="mdi mdi-content-save"></i>&nbsp; Lưu
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ThemSuaCauHinh;
